import React from 'react'
import SubHeader from '../../../../../component/common/layout/SubHeader'
import Button from '../../../../../core/Button'
import Switch from '../../../../../core/Switch'
import LogoImg from '../../../../../assets/images/logo.svg';
import LeftSidebarNew from '../../../../../component/common/layout/LeftSidebarNew'
import Header from '../../../../../component/common/layout/Header'
import { useState, useEffect } from 'react';
import { BREADCRUMB } from '@blueprintjs/core/lib/esm/common/classes';
import Axios from "axios";
import SurveyListHeader from '../../../../../component/common/layout/SurveyListHeader';
import SurveyListSidebar from '../../../../../component/common/layout/SurveyListSidebar';
import ConfigurationSidebar from '../../../../../component/common/layout/ConfigurationSidebar';
import { Link } from 'react-router-dom';
export default function Index() {

    //Survey_id
    const [survey_id, setSurveyId] = useState('');

    // Declearing variables
    const [numberOfQuestionsChecked, setNumberOfQuestionsChecked] = useState();
    const numberOfQuestionsClick = () => setNumberOfQuestionsChecked(!numberOfQuestionsChecked);

    const [cutOffDateChecked, setCutOffDateChecked] = useState();
    const cutOffDateClick = () => setCutOffDateChecked(!cutOffDateChecked);

    const [showQuestionNumber, setShowQuestionNumberChecked] = useState();
    const showQuestionNumberClick = () => setShowQuestionNumberChecked(!showQuestionNumber);

    const [limitSubmission, setLimitSubmissionChecked] = useState();
    const limitSubmissionClick = () => setLimitSubmissionChecked(!limitSubmission);

    const [sendResponseCopy, setSendResponseCopyChecked] = useState();
    const sendResponseCopyClick = () => setSendResponseCopyChecked(!sendResponseCopy);

    const [showLogo, setShowLogoChecked] = useState();
    const showLogoClick = () => setShowLogoChecked(!showLogo);
    const [surveyLogoAlignment, setsurveyLogoAlignment] = useState('Top Left')

    const [surveyTitle, setSurveyTitleChecked] = useState();
    const surveyTitleClick = () => setSurveyTitleChecked(!surveyTitle);
    const [surveyTitleAlignment, setsurveyTitleAlignment] = useState('Left')

    const [file, setFile] = useState();
    const [fileName, setFileName] = useState("");

    useEffect(() => {
        setSurveyId(localStorage.getItem('survey_id'));
        if (survey_id) {
            fetchData(survey_id);
        }
    }, [survey_id]);

    const fetchData = async (survey_id) => {

        Axios.get(process.env.REACT_APP_NODE_API_URL + "/survey/getSurveyConfig?id=" + survey_id, {
        }).then((response) => {
            if (response.data.statusCode == 200) {
                let configData = JSON.parse(response.data.result[0].su_config);


                setNumberOfQuestionsChecked((configData.numberOfQuestion === 1) ? true : false);
                setCutOffDateChecked((configData.cutOffDate === 1) ? true : false);
                setShowQuestionNumberChecked((configData.showeQuestionNumber === 1) ? true : false);
                setLimitSubmissionChecked((configData.limitSubmission === 1) ? true : false);
                sendResponseCopyClick((configData.sendResponseCopy === 1) ? true : false);

                setShowLogoChecked((configData.showLogo.is_logo === 1) ? true : false);
                setsurveyLogoAlignment((configData.showLogo.is_logo != '') ? configData.showLogo.logoAlignment : '');
                setSurveyTitleChecked((configData.surveyTitle.is_title === 1) ? true : false);
                setsurveyTitleAlignment((configData.surveyTitle.titleAlignment != '') ? configData.surveyTitle.titleAlignment : '');

            }
        });
    }

    const submitSurveyConfig = () => {

        let suv_config = {
            "numberOfQuestion": (numberOfQuestionsChecked) ? 1 : 0,
            "cutOffDate": (cutOffDateChecked) ? 1 : 0,
            "showeQuestionNumber": (showQuestionNumber) ? 1 : 0,
            "limitSubmission": (limitSubmission) ? 1 : 0,
            "sendResponseCopy": (sendResponseCopy) ? 1 : 0,
            "showLogo": { 'is_logo': (showLogo) ? 1 : 0, 'logoAlignment': (showLogo) ? surveyLogoAlignment : '' },
            "surveyTitle": { 'is_title': (surveyTitle) ? 1 : 0, 'titleAlignment': (surveyTitle) ? surveyTitleAlignment : '' },
        };

        Axios.post(process.env.REACT_APP_NODE_API_URL + "/survey/updSurveyConfig", {
            survey_id: survey_id,
            configuration: JSON.stringify(suv_config),
        }).then((response) => {
            console.log(response)
            if (response.data.response == 200) {
                alert("successfull!");
                // window.location = '/survey-creation?survey_id=' + response.data.survey_id;
            } else {
                alert("Try Again, Error");
            }
        });
    }

    //Image Uploading
    const saveFile = (e) => {
        setFile(e.target.files[0]);
        setFileName(e.target.files[0].name);
    };

    const uploadFile = async (e) => {

        //TODO API for Image Upload

        // const formData = new FormData();
        // formData.append("file", file);
        // formData.append("fileName", fileName);
        // try {
        //     const res = await  Axios.post(process.env.REACT_APP_NODE_API_URL + "/uploadSurveyLogo",
        //         formData
        //     );
        //     console.log(res);
        // } catch (ex) {
        //     console.log(ex);
        // }
    };

    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper main-site-wrapper bg-white'>
                <SurveyListHeader />
                <div id="viewport" className="flex-grow-1 d-flex survey-main-wrapper bg-white">
                    <SurveyListSidebar />
                    <div className="flex-grow-1 d-flex">
                        <ConfigurationSidebar />
                        <div className="flex-grow-1 page-content-wrap">
                            <div className="page-heading">
                                {/* breadcrumbs here */}
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/admin/survey/list">Survey</Link>
                                        </li>
                                        <li className="breadcrumb-item"><a href="#">Survey Name</a></li>
                                        <li className="breadcrumb-item">
                                            <Link to="/admin/survey/create/configuration">Configuration</Link>
                                        </li>

                                        <li className="breadcrumb-item active" aria-current="page"><strong>General</strong></li>
                                    </ol>
                                </nav>
                                {/* breadcrumbs ends here */}
                                <h1>General Configuration</h1>
                            </div>
                            <div className="main-form-wrapper configuration-section">
                                <div className="field-wrapper d-flex justify-content-between align-items-center">
                                    <div className="small-heading">
                                        <h6 className='mb-0'>Number of questions</h6>
                                    </div>
                                    <div className="switch-wrap">
                                        < Switch
                                            defaultValue='false'
                                            type='dense'
                                            color='default'
                                            checked={numberOfQuestionsChecked}
                                            disabled={false}
                                            label=''
                                            fill={false}
                                            rtl={false}
                                            leftPosition={false}
                                            className='SwitchCustom'
                                            onClick={numberOfQuestionsClick}
                                        />
                                    </div>
                                </div>
                                <div className="field-wrapper d-flex justify-content-between align-items-center">
                                    <div className="small-heading">
                                        <h6 className='mb-0'>Set cut-off date</h6>
                                    </div>
                                    <div className="switch-wrap">
                                        < Switch
                                            defaultValue='false'
                                            type='dense'
                                            color='default'
                                            checked={cutOffDateChecked}
                                            disabled={false}
                                            label=''
                                            fill={false}
                                            rtl={false}
                                            leftPosition={false}
                                            className='SwitchCustom'
                                            onClick={cutOffDateClick}
                                        />

                                    </div>
                                </div>
                                <div className="field-wrapper d-flex justify-content-between align-items-center">
                                    <div className="small-heading">
                                        <h6 className='mb-0'>Show question number</h6>
                                    </div>
                                    <div className="switch-wrap">
                                        < Switch
                                            defaultValue='false'
                                            type='dense'
                                            color='default'
                                            checked={showQuestionNumber}
                                            disabled={false}
                                            label=''
                                            fill={false}
                                            rtl={false}
                                            leftPosition={false}
                                            className='SwitchCustom'
                                            onClick={showQuestionNumberClick}
                                        />
                                    </div>
                                </div>
                                <div className="field-wrapper d-flex justify-content-between align-items-center">
                                    <div className="small-heading">
                                        <h6 className='mb-0'>Limit submission per user</h6>
                                    </div>
                                    <div className="switch-wrap">
                                        < Switch
                                            defaultValue='false'
                                            type='dense'
                                            color='default'
                                            checked={limitSubmission}
                                            disabled={false}
                                            label=''
                                            fill={false}
                                            rtl={false}
                                            leftPosition={false}
                                            className='SwitchCustom'
                                            onClick={limitSubmissionClick}
                                        />
                                    </div>
                                </div>
                                <div className="field-wrapper d-flex justify-content-between align-items-center">
                                    <div className="small-heading">
                                        <h6 className='mb-0'>Allow users to send a copy of response to themselves</h6>
                                    </div>
                                    <div className="switch-wrap">
                                        < Switch
                                            defaultValue='false'
                                            type='dense'
                                            color='default'
                                            checked={sendResponseCopy}
                                            disabled={false}
                                            label=''
                                            fill={false}
                                            rtl={false}
                                            leftPosition={false}
                                            className='SwitchCustom'
                                            onClick={sendResponseCopyClick}
                                        />
                                    </div>
                                </div>

                                <div className="field-wrapper">
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <div className="small-heading">
                                            <h6 className='mb-0'>Survey Logo</h6>
                                        </div>
                                        <div className="switch-wrap">
                                            < Switch
                                                defaultValue='false'
                                                type='dense'
                                                color='default'
                                                checked={showLogo}
                                                disabled={false}
                                                label=''
                                                fill={false}
                                                rtl={false}
                                                leftPosition={false}
                                                className='SwitchCustom'
                                                onClick={showLogoClick}
                                            />
                                        </div>
                                    </div>
                                    {(showLogo) ?
                                        <div className="survey-logo-wrapper d-flex flex-wrap">
                                            <div className="logo-inner-wrapper">
                                                <div className="logo-wrapper d-flex align-items-center">
                                                    <div className="img-wrap d-flex align-items-center justify-content-center me-3">
                                                        <img src={LogoImg} />
                                                    </div>
                                                    <input type="file" id="uploadLogo" onChange={saveFile} onInput={uploadFile} />
                                                    <label htmlFor="uploadLogo" className='btn btn-bordered'>Upload logo</label>
                                                </div>
                                            </div>
                                            <div className="alignment-wrapper mt-2 show-after">
                                                <label className='mb-2'>Alignment</label>
                                                <select className="formselect" value={surveyLogoAlignment} onInput={(e) => setsurveyLogoAlignment(e.target.value)}>
                                                    <option value="Top Left">Top Left</option>
                                                    <option value="Top right">Top right</option>
                                                    <option value="Bottom Left">Bottom Left</option>
                                                    <option value="Bottom Right">Bottom Right</option>
                                                    <option value="Center">Center</option>
                                                </select>
                                            </div>
                                        </div> : ''}
                                </div>


                                <div className="field-wrapper">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="small-heading">
                                            <h6 className='mb-0'>Survey title</h6>
                                        </div>
                                        <div className="switch-wrap">
                                            < Switch
                                                defaultValue='false'
                                                type='dense'
                                                color='default'
                                                checked={surveyTitle}
                                                disabled={false}
                                                label=''
                                                fill={false}
                                                rtl={false}
                                                leftPosition={false}
                                                className='SwitchCustom'
                                                onClick={surveyTitleClick}
                                            />
                                        </div>
                                    </div>
                                    {(surveyTitle) ?
                                        <div className="alignment-wrapper mt-2 show-after">
                                            <label className='mb-2'>Alignment</label>
                                            <select className="formselect" value={surveyTitleAlignment} onInput={(e) => setsurveyTitleAlignment(e.target.value)}>
                                                <option value="Left">Left</option>
                                                <option value="Right">Right</option>
                                                <option value="Center">Center</option>
                                            </select>
                                        </div> : ''}
                                </div>
                            </div>

                            {/* <div className="button-wrap d-flex mt-4">
                                <Button className={"theme-btn"}
                                    type="default"
                                    view="filled"
                                    color="primary"
                                    text="Create survey"
                                    onClick={submitSurveyConfig}
                                />
                            </div> */}

                        </div>
                    </div>

                </div>
            </div >

        </>
    )
}
